import { render, staticRenderFns } from "./cancel_lations_manage.vue?vue&type=template&id=1a8c9313&"
import script from "./cancel_lations_manage.vue?vue&type=script&lang=js&"
export * from "./cancel_lations_manage.vue?vue&type=script&lang=js&"
import style0 from "./cancel_lations_manage.vue?vue&type=style&index=0&id=1a8c9313&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports